<template>
	<v-btn v-bind="$attrs" v-on="$listeners" class="anemic-button" depressed>
		<slot />
	</v-btn>
</template>

<script>
export default {
	name: 'AnemicButton',
};
</script>

<style scoped lang="scss">
.anemic-button {
	background-color: #f5f5f5;
}
</style>
